// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CoLabelSwitch_logo__BFcnC {
  height: 20px;
  vertical-align: middle;
  display: inline-block;
  margin-right: 10px;
}
.CoLabelSwitch_logo__BFcnC svg, .CoLabelSwitch_logo__BFcnC img {
  height: 20px;
  width: auto;
}
.CoLabelSwitch_logo__BFcnC.CoLabelSwitch_main__xpE2Q {
  height: 36px;
}
.CoLabelSwitch_logo__BFcnC.CoLabelSwitch_main__xpE2Q svg, .CoLabelSwitch_logo__BFcnC.CoLabelSwitch_main__xpE2Q img {
  height: 36px;
}`, "",{"version":3,"sources":["webpack://./src/components/CoLabelSwitch/CoLabelSwitch.module.scss"],"names":[],"mappings":"AAEA;EACE,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,kBAAA;AAKF;AAHE;EACE,YAAA;EACA,WAAA;AAKJ;AAAE;EACE,YAAA;AAEJ;AAAI;EACE,YAAA;AAEN","sourcesContent":["@use 'styles/colors.scss';\n\n.logo{\n  height: 20px;\n  vertical-align: middle;\n  display: inline-block;\n  margin-right: 10px;\n\n  svg, img {\n    height: 20px;\n    width: auto;\n  }\n\n  // Logo affiché dans le bandeau (valeur sélectionnée) : même hauteur que sur la page de connexion\n  // (LoginLayout .logo-img = 36px) ; les logos de la liste déroulante restent à 20px.\n  &.main {\n    height: 36px;\n\n    svg, img {\n      height: 36px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colabelNeutralLight": `#F9F9FA`,
	"colabelNeutralMid": `#C3C3C9`,
	"colabelNeutralDark": `#121217`,
	"logo": `CoLabelSwitch_logo__BFcnC`,
	"main": `CoLabelSwitch_main__xpE2Q`
};
export default ___CSS_LOADER_EXPORT___;
